import { Typography } from "@stardust-ds/react"
import PlusIcon from "../../../assets/icons/PlusIcon"
import styles from "./index.module.scss"

export default function RcmpAddCard(props) {
  const { cLabel, bLarge, ...oRest } = props

  const classes = `${styles.cardsContainer} ${bLarge ? styles.largeCard : ""}`

  return (
    <div
      className={classes}
      {...oRest}
    >
      <PlusIcon
        fill="#ACB4BA"
        width="70px"
        heigth="70px"
        className={styles.addCardIcon}
      />
      <Typography type="l1" color="#ACB4BA">
        {cLabel}
      </Typography>
    </div>
  )
}
